import { renderError, renderUI } from './View';
import { MessageTypes } from 'common';
import { createOrderFacade } from './createOrderFacade';
import { InitializationErrorsCode } from './Errors/InitializationErrors';
import { storage } from './Services/storage';
import './sentryInit';
var BootstrapWidget = function (container, settings) {
    window.analytics.load(process.env.REACT_APP_SEGMENT_KEY);
    window.analytics.page();
    if (settings.forceNewTransaction) {
        storage.clearAll();
    }
    if (settings.orderToken) {
        storage.clearAll();
        storage.TOKEN.set(settings.orderToken);
    }
    storage.API_KEY.set(settings.apiKey);
    createOrderFacade(settings)
        .then(function (result) {
        renderUI(container, settings, result);
    })
        .catch(function (err) {
        var errorCode = err.errorCode || InitializationErrorsCode.UnknowingError;
        renderError(container, settings, errorCode);
    })
        .finally(function () {
        container.classList.remove('loader');
    });
};
var rootEl = document.getElementById('root');
window.addEventListener('message', function (event) {
    var data = event.data || {};
    if (data.type === MessageTypes.START_APPLICATION && rootEl) {
        var settings = data.payload;
        BootstrapWidget(rootEl, settings);
    }
});
